"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideConversationLogsSidebar = exports.showConversationLogsSidebar = exports.fetchRoutingAuditLogsAsync = void 0;
var typesafe_actions_1 = require("typesafe-actions");
exports.fetchRoutingAuditLogsAsync = (0, typesafe_actions_1.createAsyncAction)('@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_REQUEST', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_SUCCESS', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_CANCEL', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_FAIL')();
exports.showConversationLogsSidebar = (0, typesafe_actions_1.createStandardAction)('DETAILS_SIDEBAR_SHOW_CONVERSATION_LOGS_SIDEBAR')();
exports.hideConversationLogsSidebar = (0, typesafe_actions_1.createStandardAction)('DETAILS_SIDEBAR_HIDE_CONVERSATION_LOGS_SIDEBAR')();